import React, { Component } from "react";
import iconSet from "../assets/icomoon/selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Link } from "react-router-dom";
import { addEvent } from "../actions/action/events";
import { connect } from "react-redux";
import AlertBox from "../components/AlertBox";
import { isConnected } from "../helpers";

class EventAdd extends Component {
    state = {
        form: {
            title: null,
            type: null,
            description: null,
            place: null,
            at: null
        },
        disabled: false,
        alert: null
    };

    componentDidMount() {
        this.props.setPageActive(this.props.currentPage);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.alert !== undefined &&
            Object.keys(this.props.alert).length > 0 &&
            this.props.alert !== this.state.alert
        ) {
            alert(this.props.alert.content);
            
            this.setState({alert: this.props.alert});
        }

        if (
            this.props.disabled !== undefined &&
            this.props.disabled !== this.state.disabled
        ) {
            this.setState({disabled: this.props.disabled});
        }
    }

    handleFormChange = (e) => {
        this.setState({ form: {
            ...this.state.form,
            [e.target.name]: e.target.value
        }})
    }

    handleSubmit = (ev) => {
        ev.preventDefault();
        this.setState({ disabled: true });
        this.setState({
            alert: {
                type: 'warning',
                title: 'Attente',
                content: 'Enregistrement des données en cours...'
            }
        });
        this.props.addEvent({ form: this.state.form });
    }

    render() {
        return <section className="events">
            {isConnected()}
            <header className="events__header">
                <h1 className="events__ttl">Ajouter un évènement</h1>
                <nav className="events__menu">
                    <Link to="/evenements" className="btn btn--secondary">
                        <IcomoonReact iconSet={iconSet} icon="arrow-left2" />
                        Revenir en arrière
                    </Link>
                </nav>
            </header>
            <div className="events__content">
                {this.state.alert && Object.keys(this.state.alert).length > 0 && <AlertBox {...this.state.alert} />}
                <p className="form__help">* champs obligatoires</p>
                <form className="form">
                    {/** Titre */}
                    <div className="form__formgrp">
                        <label htmlFor="title" className="form__label">Titre *</label>
                        <input
                            type="text"
                            placeholder="Titre"
                            id="title"
                            name="title"
                            className="form__input"
                            value={this.state.form.title}
                            onChange={this.handleFormChange} 
                            disabled={this.state.disabled}
                            required
                        />
                    </div>
                    {/** Type */}
                    <div className="form__formgrp">
                        <label htmlFor="type" className="form__label">Type *</label>
                        <select
                            className="form__select"
                            onChange={this.handleFormChange} 
                            disabled={this.state.disabled}
                            id="type"
                            name="type"
                            required
                        >
                            <option
                                selected={this.state.form.type == null}
                                disabled
                            >-- Choisir un type --</option>
                            <option
                                selected={this.state.form.type == "Réunion"}
                                value="Réunion"
                            >Réunion</option>
                            <option
                                selected={this.state.form.type == "Évènement"}
                                value="Évènement"
                            >Évènement</option>
                            <option
                                selected={this.state.form.type == "Autre"}
                                value="Autre"
                            >Autre</option>
                        </select>
                    </div>
                    {/** Lieu */}
                    <div className="form__formgrp">
                        <label htmlFor="place" className="form__label">Lieu</label>
                        <input
                            type="text"
                            placeholder="1 rue du lieu, 79270 Frontenay Rohan Rohan"
                            id="place"
                            name="place"
                            className="form__input"
                            value={this.state.form.place}
                            onChange={this.handleFormChange} 
                            disabled={this.state.disabled}
                        />
                    </div>
                    {/** Description */}
                    <div className="form__formgrp">
                        <label htmlFor="description" className="form__label">Description</label>
                        <textarea
                            placeholder="Description"
                            id="description"
                            name="description"
                            className="form__input"
                            value={this.state.form.description}
                            onChange={this.handleFormChange} 
                            disabled={this.state.disabled}
                        ></textarea>
                    </div>
                    {/** Date et heure */}
                    <div className="form__formgrp">
                        <label htmlFor="at" className="form__label">Date et heure</label>
                        <input
                            type="datetime-local"
                            id="at"
                            name="at"
                            className="form__input"
                            value={this.state.form.at}
                            onChange={this.handleFormChange} 
                            disabled={this.state.disabled}
                        />
                    </div>
                    <div className="form__listBtn form__listBtn--row">
                        <Link to="/evenements" className="btn btn--secondary">
                            <IcomoonReact iconSet={iconSet} icon="cross" />
                            Annuler
                        </Link>
                        <button type="submit" onClick={this.handleSubmit} className="btn background">
                            <IcomoonReact iconSet={iconSet} icon="checkmark" />
                            Enregistrer
                        </button>
                    </div>
                </form>
            </div>
        </section>
    }
}

const mapStateToProps = state => {
    return state.addEvent
}

const mapDispatchToProps = {
    addEvent
}

export default connect(mapStateToProps, mapDispatchToProps)(EventAdd);